// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3cg9L","footer":"ReportModalFilter_footer__qAk6o"};